import React, { useContext } from 'react';
import moment from 'moment';
import { FilterButton } from '../../FilterButton';
import DiscoveryContext from '../../../../../contexts/discoveryContext/contextV2';
import ClearFilterButton from '../ClearFilterButton';
import { bold } from './styles.module.css';

const monthNameMapping = {
  January: 'Jan',
  February: 'Feb',
  March: 'Mar',
  April: 'Apr',
  May: 'May',
  June: 'Jun',
  July: 'Jul',
  August: 'Aug',
  September: 'Sep',
  October: 'Oct',
  November: 'Nov',
  December: 'Dec',
};

const dateDefaultLabel = 'Date';

const DateValue = ({ clearFilter, ...props }) => {
  const {
    filters: {
      date: { dateRanges, availableDates, selectedDateIds },
    },
  } = useContext(DiscoveryContext);

  let label = dateDefaultLabel;

  if (selectedDateIds?.length) {
    const dates = selectedDateIds.map((n) =>
      availableDates.find((m) => n === m.id),
    );
    label = dates.map((n) => monthNameMapping[n.label]).join(', ');
  } else if (dateRanges?.length === 1) {
    const { min, max } = dateRanges[0];
    const currentYear = moment().year();
    const mMin = moment(min);
    const mMax = moment(max);
    const minFormat = mMin.year() === currentYear ? 'D MMM' : 'D MMM YY';
    const maxFormat = mMax.year() === currentYear ? 'D MMM' : 'D MMM YY';

    const startStr = mMin.format(minFormat);
    const endStr = mMax.format(maxFormat);

    label = `${startStr} - ${endStr}`;
  }

  const isActive = label !== dateDefaultLabel;

  return (
    <FilterButton active={isActive} {...props}>
      <span className={isActive ? bold : undefined}>{label}</span>
      {isActive && <ClearFilterButton onClick={clearFilter} />}
    </FilterButton>
  );
};

export default DateValue;
